import React, { useEffect, useRef, useState,  } from 'react';
import $ from 'jquery';
import 'datatables.net-dt';
import 'datatables.net-responsive-dt';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import 'datatables.net-responsive-dt/css/responsive.dataTables.css';
import axios from "axios";
import { Get, GetList, GetTime } from '../lib/DeviceData';
import moment from 'moment';
import ECharts, { EChartsReactProps } from 'echarts-for-react';
import { useTranslation } from 'react-i18next';


const HistoryGraph = (props) => {
  const { t } = useTranslation();
  const tableRef = useRef(null);
  const dataTableRef = useRef(null);
  const [result_data, setDatas] = useState([]);

  const [bucketTime, setbucketTime] = useState([]);
  const [HrTime, sethrTime] = useState([]);
  const [RrTime, setrrTime] = useState([]);
  const [ApneaTime, setapneaTime] = useState([]);
  const [MotionTime, setmotionTime] = useState([]);
  const [FsrTime, setfsrTime] = useState([]);

  useEffect(()=> {
    fetchData();
  }, [props.data]);

  const fetchData = () => {
      try {
        const data = props.data;

        
        const device_no=data.device_no;
        const date = data.date;
        const startTime = data.start_time;
        const endTime = data.end_time;
        const start_date=moment(date+" "+startTime+":00").utc().format("YYYY-MM-DD HH:mm:ss");
        const end_date=moment(date+" "+endTime+":59").utc().format("YYYY-MM-DD HH:mm:ss");


        if(device_no && endTime){
            GetTime(device_no, start_date,end_date, res => {
                setDatas(res);
            });
            
        }

        
      } catch (error) {
        console.log("Error fetching data:", error);
      }
  };


  // datatable 초기화 중복 경고 메시지를 방지
  useEffect(() => {
    if (dataTableRef.current === null) {
      $(tableRef.current).DataTable({
        paging: false,
        pageLength: 60,
      });
      dataTableRef.current = true;
    }
  }, []);
  
  

  useEffect(() => {
    if(result_data.rows){
        var array_bucket=[];
        var array_hr=[];
        var array_rr=[];
        var array_apnea=[];
        var array_motion=[];
        var array_fsr=[];

        result_data.rows.forEach(item => {
            array_bucket.push(moment(item.bucket).format('hh:mm')); 
            array_hr.push(item.hr);
            array_rr.push(item.rr);
            array_fsr.push(item.fsr);
            if(item.motion!="-"){
                array_motion.push(item.hr);
            }else{
                array_motion.push('');
            }
            if(item.apnea!="-"){
                array_apnea.push(item.rr);
            }else{
                array_apnea.push('');
            }
        });

        setbucketTime(array_bucket);
        sethrTime(array_hr);
        setrrTime(array_rr);
        setapneaTime(array_apnea);
        setmotionTime(array_motion);
        setfsrTime(array_fsr);
    }
    // pageLength: 페이지에 보여줄 row 갯수 설정
    // columns: 데이터 key값을 넣으면 됩니다.
    if (dataTableRef.current) {
      $(tableRef.current).DataTable().destroy();
      $(tableRef.current).DataTable({
        data: result_data.rows,
        columns: [
          { data: 'bucket' },
          { data: 'hr' },
          { data: 'rr' },
          { data: 'motion' },
          { data: 'apnea' },
          { data: 'fsr' },
        ],
        columnDefs: [{
            targets: 0, //index of column
            render:function(data, type, row){
                return moment(data).format('hh:mm'); }
            },
        ],
        paging: false,
        pageLength: 60,
        destroy: true,
        responsive: true,
        ordering: false,
        searching: false,
        scrollCollapse: true,
        scrollY: '30vh',
        info:false,
      });
    }

  }, [result_data]);


var option;

var option2;

option = {
    tooltip: {
      trigger: 'axis'
    },
    legend: {},
    toolbox: {
      show: true,
      feature: {
        dataZoom: {
          yAxisIndex: 'none'
        },
        dataView: false,
        magicType: false,
        restore: false,
        saveAsImage: {}
      }
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: bucketTime
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        formatter: '{value} BPM'
      }
    },
    series: [
      {
        name: t('심박수'),
        type: 'line',
        data: HrTime,
        // markPoint: {
        //     data: [
        //         { type: 'max', name: 'Max' },
        //         { type: 'min', name: 'Min' }
        //     ]
        // },
        markLine: {
          data: [{ type: 'average', name: 'Avg' }]
        },
        color:'#ff5b45'
      },
      {
        name: t('호흡수'),
        type: 'line',
        data: RrTime,
        // markPoint: {
        //     data: [
        //         { type: 'max', name: 'Max' },
        //         { type: 'min', name: 'Min' }
        //     ]
        // },
        markLine: {
          data: [
            { type: 'average', name: 'Avg' },
          ]
        },
        color:'#3889ff'
      },
      {
        symbolSize: 13,
        name: t('움직임 감지'),
        type: 'scatter',
        data: MotionTime,
        tooltip: {
            show: false
         },
        // markPoint: {
        //     data: [
        //         { type: 'max', name: 'Max' },
        //         { type: 'min', name: 'Min' }
        //     ]
        // },
        color:'#3fd3d4'
      },
      {
        symbolSize: 13,
        name: t('무호흡'),
        type: 'scatter',
        data: ApneaTime,
        tooltip: {
            show: false
         },
        // markPoint: {
        //     data: [
        //         { type: 'max', name: 'Max' },
        //         { type: 'min', name: 'Min' }
        //     ]
        // },
        color:'#ffc73c'
      }

    ]
  };


  option2 = {
    tooltip: {
      trigger: 'axis'
    },
    legend: {},
    toolbox: {
      show: true,
      feature: {
        dataZoom: {
          yAxisIndex: 'none'
        },
        dataView: false,
        magicType: false,
        restore: false,
        saveAsImage: {}
      }
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: bucketTime
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        formatter: '{value}'
      }
    },
    series: [
      {
        name: t('압력값'),
        type: 'line',
        data: FsrTime,
        // markPoint: {
        //     data: [
        //         { type: 'max', name: 'Max' },
        //         { type: 'min', name: 'Min' }
        //     ]
        // },
        markLine: {
          data: [
            { type: 'average', name: 'Avg' },
          ]
        },
        color:'#3fd3d4'
      }

    ]
  };



  return (
    <section className='history_data_area'>
      <div className='grapharea' id='charts'>
        <ECharts option={option} opts={{ renderer: 'svg' }} style={{ width:"100%",height: 600 }} />
      </div>
      <div className='grapharea' id='charts2'>
        <ECharts option={option2} opts={{ renderer: 'svg' }} style={{ width:"100%",height: 250 }} />
      </div>
      <table ref={tableRef} className='table stripe row-border table-stripe cell-border' style={{ width: '100%' }}>
        <thead>
          <tr>
            <th>Time(min)</th>
            <th>HR(bpm)</th>
            <th>RR(bpm)</th>
            <th>Motion</th>
            <th>Apnea</th>
            <th>Fsr Sum</th>
          </tr>
        </thead>
        <tbody></tbody>
      </table>  
    </section>
  );

};

export default HistoryGraph;